export type FormatNameArgs = {
  firstName: string;
  middleName: string;
  lastName: string;
};

export const formatNameArgs = (
  primary: FormatNameArgs,
  fallback: FormatNameArgs | null | undefined
): FormatNameArgs => {
  const { firstName, middleName, lastName } = primary;
  const nameArgs = firstName || middleName || lastName ? primary : fallback;
  return (
    nameArgs || {
      firstName: '',
      middleName: '',
      lastName: '',
    }
  );
};

export const formatName = (args: FormatNameArgs): string => {
  const { firstName, middleName, lastName } = args;
  return [firstName, middleName, lastName].filter(Boolean).join(' ');
};

export const formatNameLastNameFirst = (args: FormatNameArgs): string => {
  const { firstName, middleName, lastName } = args;
  return [lastName ? lastName + ',' : undefined, firstName, middleName].filter(Boolean).join(' ');
};
